import * as React from 'react'
import { CardTitle } from 'reactstrap'
import { inject, observer } from 'mobx-react';
import {Link} from "react-router-dom";
import Tooltip from "./Tooltip"
import { normalizarString } from '../../../utils/functions'

@inject("store")
@observer
export default class TimelineHorizontal extends React.Component {

    constructor(props) {
        super(props)
        this.controller = this.props.controller;
        this.state = {
            data: this.props.information ? this.props.information.sort((a, b) => a.order - b.order) : null,
            bottomTitle: null,
            bottomIcon: null
        }
        this.borderRadius = this.props.borderRadius || true;

    }

    componentDidUpdate(prevProps) {
        if (prevProps.name !== this.props.name) {
            this.setState({
                data: this.props.information ? this.props.information.sort((a, b) => a.order - b.order) : null
            }, () => {
                this.props.information.map(elem => {
                    if (elem.extra && elem.status === 'selected') {
                        this.setState({
                            bottomTitle: elem.extra.extra_info,
                            bottomIcon: elem.extra.icon
                        })
                    } else {
                        this.setState({
                            bottomTitle: null,
                            bottomIcon: null
                        })
                    }
                })
            })
        }

    }

    componentDidMount() {
        this.state.data.map(elem => {
            if (elem.extra && elem.status === 'selected') {
                this.setState({
                    bottomTitle: elem.extra.extra_info,
                    bottomIcon: elem.extra.icon
                })
            } else {
                this.setState({
                    bottomTitle: null,
                    bottomIcon: null
                })
            }
        })
    }

    renderLine(value, status, square_status, length) {
        return (
            <React.Fragment>
                <div className={`timeline--element-horizontal-line__top timeline--element-horizontal-line__${square_status.before} ${this.props.desativado ? "desativado" : ""}`} />
                <div className={`
                        timeline--element-line__middle
                        ${this.props.desativado ? "desativado" : ""}
                        timeline--element-line__middle-${square_status.mid}
                    `}
                >
                    <div
                        className={`
                            timeline--element-line__square
                            ${this.props.desativado && square_status.mid === "selected" ? "desativado" : ""}
                            timeline--element-horizontal-line__${square_status.mid === "selected" && "selected"}
                        `}
                    />
                </div>
                <div className={`timeline--element-horizontal-line__bottom timeline--element-horizontal-line__${square_status.after} ${this.props.desativado ? "desativado" : ""}`} />
            </React.Fragment>
        )
    }

    renderTimeLineItem = (elem, index, dataLength) =>{
        return <React.Fragment>
                    <div key={index} className="d-flex mb-3 flex-column timeline--element" >
                        <div className={`mt-3 align-self-center ${elem.onClick ? "clicavel" : ""}`} onClick={elem.onClick}>
                            {<span className={`timeline--element__icon ${elem.icon ? "visible" : "invisible"} 
                                    ${elem.borderRadius ? "timeline--element__icon--border-radius" : ""}`}>
                                {elem.icon ? 
                                    elem.link && elem.exibirLink && elem.status.toUpperCase() != "INACTIVE" ?
                                        <Link className="timeline-link"  
                                              onClick={()=> this.controller.setPesquisaLink(true)} 
                                              to={{
                                                pathname: elem.link,
                                                state: {                    
                                                        voltar: elem.voltar
                                                    }
                                                }} 
                                        >
                                            {elem.icon}
                                        </Link>
                                        : 
                                        elem.icon 

                                    : ''}
                                
                            </span>}
                            
                            <div
                                //onClick={elem.onClick} //Não entendi o motivo de dois onClick, então comentei e deixo aberto para saber se há a necessidade deste outro onclick mais para a frente
                                className={`timeline--element-status ${this.props.desativado ? "desativado" : ""} ${elem.onClick ? "clickable" : ""} horizontal timeline--element-status__horizontal-${elem.status}`}
                            >   
                                {elem.link && elem.exibirLink && elem.status.toUpperCase() != "INACTIVE" ? 
                                    <Link className="timeline-link" 
                                        onClick={()=> this.controller.setPesquisaLink(true)} 
                                        to={{
                                            pathname: elem.link,
                                            state: {                    
                                                    voltar: elem.voltar
                                                }
                                            }} 
                                    >
                                        <span className="span-link">
                                            {elem.status_name}
                                        </span>
                                    </Link>
                                    :
                                    <span>
                                        {elem.status_name}
                                    </span>
                                }
                            </div>
                        </div>
                        <div className="px-0 timeline--element-horizontal-line align-self-center horizontal-line">
                            {this.renderLine(elem.order, elem.status, elem.line_control, dataLength)}
                        </div>
                        <div className={`px-1 align-self-center timeline--element-information horizontal ${elem.status === "active" && "timeline--element-information__active"}`}>
                            <div className={`timeline--element-information__main ${this.props.desativado ? "desativado" : ""}`}>
                                {elem.information}
                            </div>
                            <div className="timeline--element-information__sub-info">
                                {elem.sub_information && elem.sub_information}
                            </div>
                        </div>
                    </div>
                </React.Fragment>
                
    }

    renderTimeLineTooltip = (elem, index, dataLength, tooltipHint) =>{
        return <React.Fragment>
                    <Tooltip tooltipText={tooltipHint} position={this.props.position}>
                        <div key={index} className="d-flex mb-3 flex-column timeline--element" >
                            
                            <div className={`mt-3 align-self-center ${elem.onClick ? "clicavel" : ""}`} onClick={elem.onClick}>
                                {<span className={`timeline--element__icon ${elem.icon ? "visible" : "invisible"} 
                                        ${elem.borderRadius ? "timeline--element__icon--border-radius" : ""}`}>
                                    {elem.icon ? elem.icon : ''}
                                </span>}
                                <div
                                    onClick={elem.onClick}
                                    className={`timeline--element-status ${this.props.desativado ? "desativado" : ""} ${elem.onClick ? "clickable" : ""} horizontal timeline--element-status__horizontal-${elem.status}`}
                                >  
                                    {elem.link && process.env.ssa ? 
                                        <Link className="timeline-link" 
                                            onClick={()=> this.controller.setPesquisaLink(true)} 
                                            to={{
                                                pathname: elem.link,
                                                state: {                    
                                                        voltar: elem.voltar
                                                    }
                                                }} 
                                        >
                                            <span className="span-link">
                                                {elem.status_name}
                                            </span>
                                        </Link>
                                        :
                                        <span>
                                            {elem.status_name}
                                        </span>
                                    }
                                </div>
                            </div>
                            <div className="px-0 timeline--element-horizontal-line align-self-center horizontal-line">
                                {this.renderLine(elem.order, elem.status, elem.line_control, dataLength)}
                            </div>
                            <div className={`px-1 align-self-center timeline--element-information horizontal ${elem.status === "active" && "timeline--element-information__active"}`}>
                                <div className={`timeline--element-information__main ${this.props.desativado ? "desativado" : ""}`}>
                                    {elem.information}
                                </div>
                                <div className="timeline--element-information__sub-info">
                                    {elem.sub_information && elem.sub_information}
                                </div>
                            </div>
                        </div>
                    </Tooltip>
                </React.Fragment>
                
    }

    render() {
        const { data } = this.state;
        return (
            <React.Fragment>
                <div className="timeline text-center mb-0">
                    <div>
                        {this.props.name && <CardTitle className={`timeline--name`}>
                            <div className="timeline--img">
                                {this.props.image && this.props.image}
                            </div>
                            {this.props.name && this.props.name}
                        </CardTitle>}
                        {
                            data &&
                            <div className="d-flex flex-row timeline--information horizontal">
                                {data.map((elem, index) => {
                                    let tooltipHint = null;
                                    if (this.props.tooltips && this.props.tooltips.length > 0)
                                    {
                                        this.props.tooltips.map((t, i) => {
                                            if (normalizarString(elem.status_name).toUpperCase() === normalizarString(t.campo).toUpperCase() && t.terminalVisibility)
                                                tooltipHint = t.hint
                                        });
                                    }
                                    return tooltipHint ? this.renderTimeLineTooltip(elem, index, data.length, tooltipHint) : 
                                                         this.renderTimeLineItem(elem, index, data.length);
                                })}
                            </div>
                        }

                    </div>
                    {this.bottomIcon &&
                        <div className="timeline--name">
                            <div className="timeline--img">
                                {this.state.bottomIcon && this.state.bottomIcon}
                            </div>
                            {this.state.bottomTitle && this.state.bottomTitle}
                        </div>
                    }
                </div>
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/TimelineHorizontal.js